import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=5887ba7c&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"
import style0 from "./PersonCard.vue?vue&type=style&index=0&id=5887ba7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887ba7c",
  null
  
)

export default component.exports